module.exports = __webpack_public_path__ + "img/info-icon-publish.acd3371e.svg";